import { Component, Input, Output, OnInit, OnDestroy, EventEmitter ,AfterViewInit } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';
import { IDomain } from '@src/interfaces/domain.interfaces';
import moment from 'moment';

@Component({
    selector: 'domain-item',
    template: require('./domain-item.component.html'),
    styles: [require('./domain-item.component.scss')]
})
export class DomainItemComponent implements OnInit, AfterViewInit, OnDestroy{
    @Input()
    public set domain(value: IDomain) {
        this.validationSaveAndTest = null;
        this.prevDomain = this.deepCopy(value);
        this.domainValue = value;
    }

    public get domain(): IDomain {
        return this.domainValue;
    }

    private domainValue: IDomain;

    @Input() public hasItems: any;

    @Output() public onDelete = new EventEmitter();
    public serviceProviderType: string [] = [];
    public validationSaveAndTest: any[];
    public authenticationTypeList: any[] = [];
    public syncInProgressMsg: string;
    public isSyncEnabled: boolean = false;

    public set domainName(value: string) {
        if (this.domain) {
            this.domain.name = value;
        }
    }

    public get domainName() {
        return this.domain ? this.domain.name : '';
    }

    private unSubscribe: any;
    private prevDomain: any;
    public asyncStatus:string = "";
    public statusDate:string = "";
    public errorMsg: string = ""
    public interval:any
    // private saveValidationErrors: any[];
    private isValid: boolean;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public ngOnInit() {
        // todo: read authType data from API
        this.authenticationTypeList = [
            { id: 1, name: 'ActiveDirectory' },
            { id: 2, name: 'LDAP' }];
        this.serviceProviderType = this.authenticationTypeList.map(item => item.name);
        this.store.dispatch({ type: userActions.IS_SYNC_ENABLED })
            .then((isSync) => {
                this.isSyncEnabled = isSync;
                if(this.domain?.id){
                    this.store.dispatch({type: userActions.ASYNC_STATUS , payload: { domainId: this.domain.id }}).then(data => {
                        if(data?.value){
                            this.convertValue(data.value)
                            this.statusDate = this.convertUTCtoLocal(data.key)
                        }
                    
                    })
                }
         });
    }

    public convertValue(value){
       if(value.includes("Failed")){
          let arr = value.split(" (");
          this.asyncStatus = arr[0]
          this.errorMsg = arr[1]
       }
       else {
        this.asyncStatus = value
        this.errorMsg = ""
       }

    }

    ngAfterViewInit(): void {
            this.interval = setInterval(() => {
                if(this.isSyncEnabled){
                    this.store.dispatch({type: userActions.ASYNC_STATUS , payload: { domainId: this.domain.id }}).then(data => {
                        this.convertValue(data.value)
                        this.statusDate = this.convertUTCtoLocal(data.key)
                    })
                }
            },3000)
         
    }

    ngOnDestroy(): void {
        clearInterval(this.interval)
    }

    public async save() {
        if (!await this.validateSaveForm()) {
            return;
        }
        const translations = await this.translatePipe.transform([
            'ERROR', 'ERROR_CREATE_DOMAIN']);
        if (!this.domain) {
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_CREATE_DOMAIN']
            });
        } else {
            if (this.domain.isNew) {
                this.unSubscribe = this.store.subscribe(() => {
                    const userState = this.store.getState().user;
                    if (userState.domains) {
                        delete this.domain.isNew;
                        if (userState.domain && userState.domain.id) {
                            this.domain.id = userState.domain.id;
                            this.domain.groupsMapping.domainId = userState.domain.id;
                        }
                        this.prevDomain = this.deepCopy(this.domain);
                        this.unSubscribe();
                    }
                });
                this.store.dispatch({
                    type: userActions.ADD_DOMAIN,
                    payload: { domainData: this.domain }
                });
            } else {
                const saveID = this.domain.id;
                this.unSubscribe = this.store.subscribe(() => {
                    if (this.store.getState().user.domain) {
                        this.domain.id = saveID;
                        this.domain.groupsMapping.domainId = saveID;
                        this.prevDomain = this.deepCopy(this.domain);
                        this.unSubscribe();
                    }
                });
                this.store.dispatch({
                    type: userActions.SAVE_DOMAIN,
                    payload: { domainId: this.domain.id, domainData: this.domain }
                });
            }
        }
    }

    convertUTCtoLocal(date) {
        if (!date)
            return;
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }

    public cancel() {
        this.domain = this.prevDomain;
    }

    private async validateSaveForm() {
        const saveValidationErrors = [];
        this.isValid = true;
        if (this.domain.manualSettings) {
            saveValidationErrors[0] = await this.checkEmpty(this.domain.domainHost, 'ERROR_NO_HOST_NAME');
            saveValidationErrors[1] = await this.checkEmpty(this.domain.domainPort, 'ERROR_NO_PORT');
            if (!this.domain.anonymousAuth) {
                saveValidationErrors[2] = await this.checkEmpty(this.domain.userDN, 'ERROR_USERNAME_REQUIRED');
                if (!this.domain.id) {
                    saveValidationErrors[3] =
                        await this.checkEmpty(this.domain.password, 'ERROR_PASSWORD_RQUEIRED');
                }
            } else {
                saveValidationErrors[2] = '';
                saveValidationErrors[3] = '';
            }
            saveValidationErrors[4] = await this.checkEmpty(this.domain.baseDN, 'ERROR_NO_BASEDN');
        }
        // commented those tests because they are for the whole form (check for logon, first and last name)
        // this.saveValidationErrors[5] = await this.checkEmpty(this.domain.logonAttribute,
        // 'ERROR_LOGON_NAME_RQUEIRED');
        // this.saveValidationErrors[6] = await this.checkEmpty(this.domain.firstNameAttribute, 'ERROR_FNAME_RQUEIRED');
        // this.saveValidationErrors[7] = await this.checkEmpty(this.domain.lastNameAttribute, 'ERROR_LNAME_RQUEIRED');
        this.validationSaveAndTest = await saveValidationErrors.filter((v, i, a) => a.indexOf(v) === i);
        return this.isValid;
    }

    private async checkEmpty(field: any, errorMsg: any) {
        if (this.isFieldEmpty(field)) {
            this.isValid = false;
            const translations = await this.translatePipe.transform([errorMsg]);
            return translations[errorMsg];
        }
    }

    public testValidate(testValidationErrors: any) {
        this.validationSaveAndTest = testValidationErrors.filter((v: any, i: any, a: any) => a.indexOf(v) === i);
    }

    public onSwitch() {
        this.validationSaveAndTest = null;
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }

    private isFieldEmpty(value: any) {
        return !value || value.toString().trim().length === 0;
    }

    public selectedProvider(provider: string): void {
        if (provider) {
            const type = this.authenticationTypeList.find(x => x.name === provider) || this.authenticationTypeList[0];
            this.domain.authenticationType = type.id;
        }
    }

    public syncAll(): void {
        this.store.dispatch({
            type: userActions.SYNC_ALL_USERS_PERMISSIONS,
            payload: { domainId: this.domain.id }
        }).then(x=> {
             this.store.dispatch({ type: userActions.GET_USERS })
             if(x){
                 
             }
        })
    }

    public getPlaceholder(): string {
        return (this.domain && this.domain.authenticationType) ?
            this.serviceProviderType[this.domain.authenticationType - 1] :
            this.serviceProviderType[0];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-item/domain-item.component.ts